
namespace TabAurous.Inventory{

     
    @Serenity.Decorators.registerClass()
    export class LocationTransferRegisterGrid extends Serenity.EntityGrid<LocationTransferRow, any> {
        protected getColumnsKey() { return 'Inventory.LocationTransfer'; }
        protected getDialogType() { return LocationTransferDialog; }
        protected getIdProperty() { return LocationTransferRow.idProperty; }
        protected getInsertPermission() { return LocationTransferRow.insertPermission; }
        protected getLocalTextPrefix() { return LocationTransferRow.localTextPrefix; }
        protected getService() { return LocationTransferService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
          

            return filters;
        }
        //onViewProcessData(response: Serenity.ListResponse<LocationTransferRow>) {

        //    if (!this.chartContainer) {
        //        this.chartContainer = $("<div style='padding: 20px 0' />");
        //        this.chartContainer.insertBefore(this.element.find(".grid-container"));
        //    }

        //    if (this.chartPanel) {
        //        this.chartPanel.destroy();
        //    }

        //    this.chartPanel = new ChartPanel(this.chartContainer, { items: response.Entities });

        //    var options = {
        //        chart: {
        //            type: 'bar'
        //        },
        //        series: [
        //            {
        //                name: 'sales',
        //                data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
        //            }
        //        ],
        //        xaxis: {
        //            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
        //        }
        //    }

        //    var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

        //    chart.render();


        //    return response;
        //}

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    
                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date:this.view.params.Criteria
                        }
                    });
                }
            }
            );
            return buttons;
        }
    }
}